<template>
  <div class="home">
    <HeaderGlobal :secondaryHeader="false" :qtSomos="qtSomos" />
    <!-- Page Content Desktop -->
    <div class="container-fluid">
      <div class="container border-left-light pt-2 pb-5">
        <div class="row">
          <div
            class="col-md-6 mx-auto px-5 pl-md-1 pr-md-0 pl-lg-5 pr-lg-0 text-center"
          >
            <div class="text-center">
              <img :src="imgPath" style="max-width: 100%; max-height: 100px;" class="mb-5" alt="" />
              <h2 class="text-second-color">Obrigado, {{ nome }}!</h2>
              <p class="text-first-color" style="white-space: pre-line">{{ template.thank }}</p>

              <h3 class="text-second-color">{{ nome }} {{ sobreNome }}</h3>
              <h3 class="text-second-color">{{ userId }}</h3>
              {{ response }}
              <qrcode-vue
                v-if="template.QRCodeShow"
                class="mt-5"
                :value="voucher.qrData"
                render-as="svg"
                :size="size"
                level="L"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterGlobal :secondaryFooter="false" :qtSomos="qtSomos" />
  </div>
</template>

<script>
import FooterGlobal from "./FooterGlobal";
import HeaderGlobal from "./HeaderGlobal";
import QrcodeVue from "qrcode.vue";
import { Survey } from "@/services/Survey.js";
const surveyServices = new Survey();

export default {
  name: "finalsurvey11",
  components: {
    FooterGlobal,
    HeaderGlobal,
    QrcodeVue,
  },
  data: () => ({
    qtSomos: 0,
    size: 200,
    voucher: null,
  }),
  computed: {
    userId() {
      return this.$store.state.userId;
    },
    projectTag() {
      return "#" + this.$store.state.project.projectTag;
    },
    hashtags() {
      return (
        this.$store.state.project.projectTag +
        "," +
        this.$store.state.project.aditionalTags
      );
    },
    company() {
      return this.$store.state.project.entityName;
    },
    sharingMessage() {
      return this.$store.state.project.sharingMessage;
    },
    projectURL() {
      return "https://" + this.$store.state.project.projectURL + "/";
    },
    projectTitle() {
      return this.$store.state.project.projectTitle;
    },
    nick() {
      return this.$store.state.project.nickName;
    },

    nome() {
      var n = this.fillString("<@RQ:101@>");
      return n;
    },
    sobreNome() {
      var n = this.fillString("<@RQ:102@>");
      return n;
    },
    template() {
      return this.$store.state.template.finalSurvey;
    },
    imgPath() {
      let array = this.$store.state.template.header.logos;
      let obj = array.pop();
      let path = obj.logo;
      return path;
    },
    surveyUserId() {
      return this.$store.state.surveyUserId;
    },
  },
  methods: {
    fillString(s) {
      if (!s) return s;
      if (s.includes("<@") && s.includes("@>")) {
        var s1 = s.split("<@");
        var s2 = s1[1].split("@>");
        var s3 = s2[0].split(":");
        var rid = s3[1];
        var value = this.$store.state.answers[rid];
        s = s1[0] + value + s2[1];
      }
      return s;
    },
    loadVoucher() {
      surveyServices
        .SurveyVoucher(this.surveyUserId)
        .then((res) => {
          this.voucher = res;
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
  created() {
    this.$gtag.event("FinalSurvey", { method: "Google" });
    this.qtSomos = this.$store.state.qtUsers;
  },
  beforeMount() {
    if (!this.$store.state.template.style) {
      this.$nextTick(() => {
        this.$router.push('home')
      })
    }
  },
  mounted() {
    if (this.template.QRCodeShow){
      this.loadVoucher();
    }
  },
};
</script>

<style scoped>
.container {
  min-height: calc(100vh - 91px - 148.11px);
}
.c-sharing {
  font-size: 1.5rem;
  font-weight: 300;
}
</style>
